import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';

@Component({
  selector: 'app-charts-test',
  templateUrl: './charts-test.component.html',
  styleUrls: ['./charts-test.component.css'],
  standalone: false
})
export class ChartsTestComponent implements AfterViewInit, OnDestroy {
  @ViewChild('chartCanvas') chartCanvas!: ElementRef<HTMLCanvasElement>;
  private chartInstance?: Chart;

  ngAfterViewInit(): void {
    this.buildChart();
  }

  ngOnDestroy(): void {
    this.destroyChart();
  }

  refreshChart(): void {
    this.destroyChart();
    this.buildChart();
  }

  private buildChart(): void {
    if (!this.chartCanvas?.nativeElement) {
      console.error('ChartsTest: canvas missing');
      return;
    }

    const data = {
      labels: ['Alpha', 'Beta', 'Gamma', 'Delta', 'Epsilon'],
      datasets: [
        {
          label: 'Mock Metric',
          data: [12, 19, 7, 15, 10],
          backgroundColor: [
            'rgba(54, 162, 235, 0.5)',
            'rgba(255, 99, 132, 0.5)',
            'rgba(255, 206, 86, 0.5)',
            'rgba(75, 192, 192, 0.5)',
            'rgba(153, 102, 255, 0.5)',
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
            'rgba(255, 99, 132, 1)',
            'rgba(255, 206, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(153, 102, 255, 1)',
          ],
          borderWidth: 1,
        },
      ],
    };

    const config = {
      type: 'bar' as const,
      data,
      options: {
        responsive: true,
        plugins: {
          legend: { display: true },
        },
        scales: {
          y: {
            beginAtZero: true,
          },
        },
      },
    };

    this.chartInstance = new Chart(this.chartCanvas.nativeElement, config);
  }

  private destroyChart(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = undefined;
    }
  }
}
